import { useContext } from "react";
import { OrganizationContext } from "common/providers/OrganizationProvider";

export const useAuth = () => useContext(OrganizationContext);

export default useAuth;
